//imports
import React, { Components, version } from 'react';
import { Card, Button, CardTitle, CardDeck, CardHeader, CardBody, CardText, Row, Col, CardSubtitle } from 'reactstrap';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content';
import {schnorr} from '@zilliqa-js/crypto';

//Globals
const { StatusType, MessageType } = require('@zilliqa-js/subscriptions');
const sha256 = require('js-sha256');

const { BN, Long, bytes, units } = require('@zilliqa-js/util');
const { Zilliqa } = require('@zilliqa-js/zilliqa');
const {toBech32Address,getAddressFromPrivateKey} = require('@zilliqa-js/crypto');
const { Transaction } = require('@zilliqa-js/account');
//Testnet and Mainnet
//const zilliqa = new Zilliqa('https://dev-api.zilliqa.com');
const zilliqa = new Zilliqa('https://api.zilliqa.com');

const chainIdDev = 333; // chainId of the developer testnet
const chainId = 1

const msgVersion = 1; // current msgVersion
const VERSION = bytes.pack(chainId, msgVersion);

const zilpay = window.zilPay;
//SwalAlerts
const MySwal = withReactContent(Swal);

    
    const contractBech32 = 'zil1p2cp77kz06wlxeyha4psawencm5gx8ttcwsxdn';
    const contractBase16 = '0xA9d7d94a22aB16f5414BdfDAc4A563a7CdbD6283';
 
 export default class CrowdSale extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      value: '',
      userAccount: '',
      contractAddr: '',
      zilBalance:0,
      contractInit:'',
      contractState:'',
      claimValue:'',
      login:false,
      enabled:false,
      isButtonDisabled:true,
      tokenBalance:0,
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeClaim=this.handleChangeClaim.bind(this);
    this.handleSubmitClaim=this.handleSubmitClaim.bind(this);
    //this.fetchDonate=this.fetchDonate.bind(this);
    this.signMessage = this.signMessage.bind(this);
    this.claimBack=this.claimBack.bind(this);
    this.buyKKZ=this.buyKKZ.bind(this);
    this.testTrans=this.testTrans.bind(this);


  }

  async componentDidMount() {
    const login=await window.zilPay.wallet.connect()
    if(!login){

MySwal.fire({
  title:"You need to login first...."
});
    }else{

      this.setState({
        login:true
      })

MySwal.fire({
  title:'You are connected'
});

    this.getContract()
    this.fetchUserAccount();
    this.initContract();
    this.getZilBalance();
    this.getBlockchainStats();
  }
}


async fetchUserAccount() {   
  const userAddress = zilpay.wallet.defaultAccount;
  const userAddressBase16=userAddress.base16;
  const userAddressBech32 = userAddress.bech32;
  const isValidAddress = window.zilPay.crypto.isValidChecksumAddress(userAddressBase16);
  if(isValidAddress === true){

  this.setState({
    userAddress: userAddressBech32
  })
}else{

  MySwal.fire({
    title:'You need to log in to interact...',
    icon:'error'
  });
}  
}

async getZilBalance(){
  try{
    const balanceZil=await zilpay.blockchain.getBalance(this.state.userAddress);
    if(balanceZil){
      let zilnow=balanceZil.result.balance/1000000000000;

      this.setState({
        zilBalance:zilnow
      })
    }

  }catch(error){
    console.log(error)

  }
}



  async getContract() {

    const contractAddr = contractBech32;

    this.setState({
      contractAddr: contractAddr
    })
  }

  async initContract(){
    const contract =await window.zilPay.contracts.at(contractBech32);//kkz
    const contractInit=await contract.getInit().then((init)=>{

      this.setState({
        contractInit:init
      })
    });

    const cState=await contract.getState().then((contractState)=>{
      var cBalance=contractState._balance/1000000000000;
      this.setState({
        contractState:cBalance
      })

    });  
  }

  handleChangeClaim(event){
    this.setState({
      claimValue:event.target.value
    })
  }
handleSubmitClaim(event){
  event.preventDefault();
console.log("Clickeed....");
//this.claimBack()
}

  handleChange(event) {
    this.setState({ value: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    if (this.state.value != 0) {

      this.buyKKZ();

    } else {

      MySwal.fire({
        title: 'Error',
        text: 'You need to enter more than 0',
        icon: 'error'
      });
    }
  }

  async getBlockchainStats(){
    const blockchain = window.zilPay.blockchain;
const result = await blockchain.getBlockChainInfo();
console.log('blkstatss....',result.result.CurrentMiniEpoch)
}

  async signMessage(){
    const message='Testing...';
    const {signature,publicKey} = await zilpay.wallet.sign(message);
    console.log('signature',signature)

  }

  async claimBack(){
    const deployedC=this.state.contractAddr;
    //const deployedContract=await zilpay.contracts.at('0x9dbfbda58865bf1ecb5b60def4c638994a8cb4d6');
    const claim = deployedC.call(
      'ClaimBack',[],{
        tag:'ClaimBack',
        version:VERSION,
        toAddr:this.state.userAddress,
        gasPrice:units.toQa("20000",units.Units.Li),
        gasLimit:Long.fromNumber(1000),
      }
    )
    console.log(claim.id)
  }

async buyKKZ(){
  const buyer=this.state.userAddress;
  const myAddr='0xA9d7d94a22aB16f5414BdfDAc4A563a7CdbD6283';
  const amtToBuy=this.state.value;

  const tx=await window.zilPay.blockchain.createTransaction({
    version:VERSION,
    toAddr:myAddr,
    amount:units.toQa(amtToBuy,units.Units.Zil),
    gasPrice:units.toQa("20000",units.Units.Li),
    gasLimit:Long.fromNumber(1000),

  })

  if(!tx){
    console.log('err')
  }else{
    console.log(tx)
    this.testTrans();
  
  }

}

  async testTrans(){
    const deployedContract=await zilpay.contracts.at('0x9dbfbda58865bf1ecb5b60def4c638994a8cb4d6');
    const sendAmt=this.state.value.toString()
    const newV=toString(sendAmt)
    const tx = deployedContract.call(
      'Transfer',[],
      {
      tag:'Transfer',
      version:VERSION,
      toAddr:'0x9dbfbda58865bf1ecb5b60def4c638994a8cb4d6',
      amount:units.toQa(sendAmt,units.Units.Zil),
      gasPrice:units.toQa("20000",units.Units.Li),
      gasLimit:Long.fromNumber(1000),
    })
   // tx=await zilpay.blockchain.createTransaction(tx);
    console.log(tx.id);
  }

  render() {

    return (
      <div>
        <div>
          <center>
          <Card body inversse style={{ maxWidth: '600px', backgroundColor: '#333', borderColor: 'lime', color: 'white', display: 'flex' }}>

Your Address: {this.state.userAddress}<br />
            <br />
            Your Zil Balance: {this.state.zilBalance}
            <br/><br/>

          </Card>
        </center>
          <br />
      </div>
    
</div>
    );

  }
}
